import { createStore } from 'easy-peasy';
import user from './user';
import general from './general';
import productExceptions from './productExceptions';
import { StoreModel } from './types';
import maxDiscounts from './maxDiscounts';
import minMargins from './minMargins';
import pricingRules from './pricingRules';
import pricingRulesVp from './pricingRulesVp';
import topNCategories from './topNCategories';
import dashboardProducts from './dashboardProducts';
import dashboardProductsVp from './dashboardProductsVp';
import dashboardReports from './dashboardReports';
import configuration from './configuration';

export const store: StoreModel = {
  user,
  general,
  productExceptions,
  configuration,
  maxDiscounts,
  minMargins,
  pricingRules,
  pricingRulesVp,
  topNCategories,
  dashboardReports,
  dashboardProducts,
  dashboardProductsVp
};

export default createStore(store);
